import App from 'src/pages/app/[...]';

// eslint-disable-next-line import/no-default-export
export default App;
